import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Photo from 'layout/atoms/Photo/Photo';
import Grid from 'layout/molecules/Grid/Grid';
function Photos({ photoAdd, photoDelete }) {
    var _a;
    const { t } = useTranslation(['specification', 'common']);
    const storeData = useSelector((state) => state.componentDetails);
    const pictures = Array.isArray((_a = storeData === null || storeData === void 0 ? void 0 : storeData.item) === null || _a === void 0 ? void 0 : _a.pictures) ? storeData.item.pictures : [];
    return (React.createElement(Grid, { columns: 4 },
        pictures.map((photo) => {
            var _a;
            return (React.createElement(Photo, { size: "m", noMinHeight: true, key: photo.id, src: photo.picture, alt: ((_a = storeData === null || storeData === void 0 ? void 0 : storeData.item) === null || _a === void 0 ? void 0 : _a.name) || '', onPhotoDelete: () => photoDelete(photo.id) }));
        }),
        photoAdd && (React.createElement(Photo, { size: "m", noMinHeight: true, alt: t('add_image'), onPhotoAdd: photoAdd, onPhotoDelete: photoDelete }))));
}
export default Photos;
